module.exports = __webpack_public_path__ + "img/background_222.3b841a06.png";